var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { setStyleEl } from '../util/dom';
import WithRender from './ImageGallery.html';
const IMAGE_GALLERY_CLASS = 'gallery__list';
const IMAGE_PREVIEW_CLASS = 'gallery__image-preview';
const DEFAULT_OPTIONS = {
    useAsImagePreview: false,
    gridCellHeight: 200,
    gridCellWidth: 200,
    images: []
};
let ImageGallery = class ImageGallery extends Vue {
    mounted() {
        // TODO: Refactor this component
        if (!this.imageGalleryOptions.useAsImagePreview) {
            // Set grid dimensions
            setStyleEl(this.$refs.galleryWrapper, 'grid-template-columns', `repeat(auto-fill, minmax(${this.imageGalleryOptions.gridCellWidth}px, 1fr)`);
            setStyleEl(this.$refs.galleryWrapper, 'grid-auto-rows', `${this.imageGalleryOptions.gridCellHeight}px`);
        }
        else {
            setStyleEl(this.$refs.galleryWrapper, 'width', `${this.imageGalleryOptions.gridCellWidth}px`);
            setStyleEl(this.$refs.galleryWrapper, 'height', `${this.imageGalleryOptions.gridCellHeight}px`);
        }
    }
    get imageGalleryOptions() {
        return Object.assign({}, DEFAULT_OPTIONS, this.options);
    }
    get imageGalleryClass() {
        return this.imageGalleryOptions.useAsImagePreview
            ? IMAGE_PREVIEW_CLASS
            : IMAGE_GALLERY_CLASS;
    }
    onCloseImage(index) {
        this.$emit('close', index);
    }
};
__decorate([
    Prop(),
    __metadata("design:type", Object)
], ImageGallery.prototype, "options", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Boolean)
], ImageGallery.prototype, "isLoading", void 0);
ImageGallery = __decorate([
    WithRender,
    Component({})
], ImageGallery);
export default ImageGallery;
//# sourceMappingURL=ImageGallery.js.map